// @flow

import * as R from "ramda";
import type { ChecklistBuilderField } from "src/types";

export const filterFields = (
  fields: ChecklistBuilderField[],
  forbiddenFieldTypes: string[]
) => R.reject(field => forbiddenFieldTypes.includes(field.type), fields);
